import { render, staticRenderFns } from "./TabBudgetExtraServices.vue?vue&type=template&id=0088d4b7&scoped=true"
import script from "./TabBudgetExtraServices.vue?vue&type=script&lang=ts"
export * from "./TabBudgetExtraServices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0088d4b7",
  null
  
)

export default component.exports